<template>

  <div class="row">

    <div class="col-lg-8">
      <div class="dashboard-block">
        <h2>Invoices</h2>

        <ul class="item-detail item-detail-payment">
          <li>
            <invoice-item :booking="booking" />
          </li>
        </ul>

      </div>

    </div>

    <div class="col-lg-4">
      <div class="dashboard-block">
        <help-steps v-if="helpSteps.length" :steps="helpSteps" />
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import { helpers } from 'mixins/bookings'
import HelpSteps from '../globals/HelpSteps'
import InvoiceItem from './InvoiceItem'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  components: {
    HelpSteps,
    InvoiceItem
  },

  computed: {
    ...mapState('booking', ['booking']),

    helpSteps () {
      return [
        {
          title: 'Invoices',
          content: `<p>You will be able to access your invoice here once your booking is confirmed. It may take 1-2 business days for your invoice to appear.</p>`
        }
      ]
    }
  }
}
</script>
